import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import api from "../../services/api";

export default function useFiles(companyId, socket, enabled) {
 const [files, setFiles] = useState([]), [count, setCount] = useState(0);
 const [page, setPage] = useState(0), [pageSize, updatePageSize] = useState(25);
 const [search, setSearch] = useState(""), [query, setQuery] = useState("");
 const [revision, setRevision] = useState(0), [loading, setLoading] = useState(enabled), [error, setError] = useState(false);
 const sequence = useRef(0);
 const refresh = useCallback(() => setRevision(value => value + 1), []);
 const setPageSize = value => { updatePageSize(value); setPage(0); };
 useEffect(() => {
  if (search.trim() === query) return undefined;
  const timer = setTimeout(() => { setPage(0); setQuery(search.trim()); }, 300);
  return () => clearTimeout(timer);
 }, [search, query]);
 useEffect(() => {
  if (!enabled || !companyId) { setFiles([]); setCount(0); setLoading(false); return undefined; }
  const request = ++sequence.current, cancel = axios.CancelToken.source();
  setLoading(true); setError(false);
  api.get("/files", { params: { searchParam: query, pageNumber: page + 1, pageSize }, timeout: 20000, cancelToken: cancel.token })
   .then(({ data }) => {
    if (request !== sequence.current) return;
    if (!Array.isArray(data.files) || !Number.isFinite(Number(data.count))) throw new Error("Invalid file list");
    const total = Number(data.count), last = Math.max(0, Math.ceil(total / pageSize) - 1);
    if (page > last) { setPage(last); return; }
    setFiles(data.files); setCount(total);
   })
   .catch(err => { if (request === sequence.current && !axios.isCancel(err)) setError(true); })
   .finally(() => { if (request === sequence.current) setLoading(false); });
  return () => { sequence.current = request + 1; cancel.cancel(); };
 }, [companyId, enabled, page, pageSize, query, revision]);
 useEffect(() => {
  if (!enabled || !socket || !companyId) return undefined;
  let timer;
  const changed = data => { if (["create", "update", "delete", "reset"].includes(data?.action) && !timer) timer = setTimeout(() => { timer = null; refresh(); }, 250); };
  const event = "company" + companyId + "-file";
  socket.on(event, changed);
  return () => { clearTimeout(timer); socket.off(event, changed); };
 }, [companyId, socket, enabled, refresh]);
 return { files, count, page, setPage, pageSize, setPageSize, search, setSearch, loading, error, refresh };
}